<!--
  offer_modal--all-in is the flag's hook in CSS, matching buy_now_modal--all-in and bid_modal--all-in.
  Every chrome change M4.14 makes to this shell hangs off it, so the kill switch is one class away and
  nothing in the stylesheet needs its own conditional. See isAllInPricingEnabled for why this follows
  the flag rather than the hosted action's showDripBreakdown.
-->
<app-modal
  [modalId]="currentModalId || modalId"
  class="offer_modal"
  [class.offer_modal--all-in]="isAllInPricingEnabled">
  @if (isLoading) {
    <div class="loader-container">
      <app-spinner></app-spinner>
    </div>
  }
  <div [hidden]="isLoading">
    <ng-template appOfferModal></ng-template>
  </div>
</app-modal>
